import type { BudgetMonth } from './types'
import { monthTotals } from './calc'
import { formatCurrency } from './format'

export function ToBeAssignedHeader({ month }: { month: BudgetMonth }) {
  const totals = monthTotals(month)
  const value = totals.toBeAssigned
  const isOver = value < 0
  const isZero = value === 0

  // Color semantics match iOS: red = overspent, green = exactly
  // assigned, neutral = positive remaining. Contrast ratios per token
  // table in tailwind.config.ts.
  const color = isOver
    ? 'bg-overspent-subtle text-overspent'
    : isZero
      ? 'bg-funded-subtle text-funded'
      : 'bg-zinc-100 text-zinc-900 dark:bg-zinc-800 dark:text-zinc-100'

  return (
    <div
      className={`flex items-baseline justify-between rounded-xl px-5 py-4 ${color}`}
      role="status"
      aria-live="polite"
      aria-label={`To be assigned: ${formatCurrency(value)}`}
    >
      <div>
        <div className="text-xs font-medium uppercase tracking-wide opacity-70">To Be Assigned</div>
        <div className="text-3xl font-bold tabular-nums">{formatCurrency(value)}</div>
      </div>
      <div className="text-right text-xs opacity-70">
        <div>Income: {formatCurrency(month.income)}</div>
        <div>Assigned: {formatCurrency(totals.assigned)}</div>
      </div>
    </div>
  )
}
